import { Component } from "@angular/core"
import { environment } from "src/environments/environment"

@Component({
	selector: "app-modal-legenda",
	templateUrl: "./modal-legenda.component.html",
	styleUrls: ["./modal-legenda.component.scss"]
})
export class ModalLegendaComponent {
	public assets_version = environment.ASSETS_VERSION
	public pathImgsMarkers = environment.path_imgs_markers
}
